/**
 * Layout: Actueel overzicht
 * Slug: actueel_overview
 * Server side: includes/actueel-filter.php (action pk_child_actueel_filter).
 */

const ACTION = "pk_child_actueel_filter";
const SEARCH_DELAY = 300;

const initActueelOverview = (root) => {
    const form = root.querySelector("[data-filter-form]");
    const results = root.querySelector("[data-results]");
    const empty = root.querySelector("[data-empty]");
    const pagination = root.querySelector("[data-pagination]");
    const { ajaxUrl } = root.dataset;

    if (!form || !results || !ajaxUrl) return;

    let page = Number(new URLSearchParams(location.search).get("pagina")) || 1;
    let requestId = 0;
    let timer;

    const readState = () => ({
        categorie: form.elements.categorie?.value ?? "",
        search: form.elements.search.value.trim(),
    });

    const writeState = (params) => {
        if (form.elements.categorie) form.elements.categorie.value = params.get("categorie") ?? "";
        form.elements.search.value = params.get("search") ?? "";
    };

    const updateUrl = (push) => {
        const params = new URLSearchParams();
        for (const [name, value] of Object.entries(readState())) if (value) params.set(name, value);
        if (page > 1) params.set("pagina", page);

        const url = `${location.pathname}${params.size ? `?${params}` : ""}`;
        history[push ? "pushState" : "replaceState"](null, "", url);
    };

    const load = async (nextPage) => {
        const id = ++requestId;
        const { categorie, search } = readState();
        const body = new URLSearchParams({ action: ACTION, category: categorie, search, paged: nextPage });

        root.classList.add("is-loading");

        try {
            const response = await fetch(ajaxUrl, { method: "POST", body });
            const json = await response.json();
            if (id !== requestId || !json.success) return;

            const { html, pagination: paginationHtml, total } = json.data;
            results.innerHTML = html;
            window.pkButtonTextAnimation?.(results);

            // The server may clamp a page past the end; keep the URL in line with what is shown
            if (json.data.page !== nextPage) {
                page = json.data.page;
                updateUrl(false);
            }
            if (empty) empty.hidden = total > 0;
            if (pagination) {
                pagination.innerHTML = paginationHtml;
                pagination.hidden = !paginationHtml;
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (id === requestId) root.classList.remove("is-loading");
        }
    };

    const applyFilters = (push) => {
        clearTimeout(timer);
        page = 1;
        updateUrl(push);
        load(1);
    };

    form.addEventListener("change", (event) => {
        if (event.target.name === "categorie") applyFilters(true);
    });

    // Typing replaces the history entry; Enter or the icon search right away
    form.elements.search.addEventListener("input", () => {
        clearTimeout(timer);
        timer = setTimeout(() => applyFilters(false), SEARCH_DELAY);
    });

    form.addEventListener("submit", (event) => {
        event.preventDefault();
        applyFilters(false);
    });

    pagination?.addEventListener("click", (event) => {
        const link = event.target.closest("[data-page]");
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;

        event.preventDefault();
        page = Number(link.dataset.page);
        updateUrl(true);
        load(page);

        // Back to the top of the list, unless it is already in view
        if (results.getBoundingClientRect().top < 0) {
            const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
            results.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
        }
    });

    window.addEventListener("popstate", () => {
        const params = new URLSearchParams(location.search);
        writeState(params);
        clearTimeout(timer);
        page = Number(params.get("pagina")) || 1;
        load(page);
    });
};

const initAll = () => document.querySelectorAll("[data-actueel-overview]").forEach(initActueelOverview);

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
} else {
    initAll();
}
